import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FilterOptions } from './notification-filter.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationFilterService {

  private typeEle = {
    label: '',
    value: ''
  };
  private statusEle = {
    label: '',
    value: ''
  };
  private countryEle = {
    label: '',
    value: ''
  };
  private typeFilter = new BehaviorSubject(this.typeEle);
  private statusFilter = new BehaviorSubject(this.statusEle);
  private countryFilter = new BehaviorSubject(this.countryEle);
  private filterNotificationData = new Subject<FilterOptions>();
  // Observable string streams

  public typeFilterobservable$ = this.typeFilter.asObservable();
  public statusFilterobservable$ = this.statusFilter.asObservable();
  public countryFilterobservable$ = this.countryFilter.asObservable();
  public filterData$ = this.filterNotificationData.asObservable();
  // Service message commands

  public typeFilStore: { label: string; value: string }[] = [];
  public statusFilStore: { label: string; value: string }[] = [];
  public countryFilStore: { label: string; value: string }[] = [];

  public typeListStore:any[];
  public statusListStore:any[];
  public countryListStore:any[];

  public setTypeName(d: any): void {
    this.typeEle.label = d;
    this.typeEle.value = d;
    this.typeFilter.next(this.typeEle);
    this.typeEle = { label: '', value: '' };
  }

  public setStatusName(d: any): void {
    this.statusEle.label = d;
    this.statusEle.value = d;
    this.statusFilter.next(this.statusEle);
    this.statusEle = { label: '', value: '' };
  }

  public setCountryName(d: any): void {
    this.countryEle.label = d;
    this.countryEle.value = d;
    this.countryFilter.next(this.countryEle);
    this.countryEle = { label: '', value: '' };
  }

   public setTypeFilStore(ls){
    this.typeFilStore=[];
    if(ls.length!=0){
      ls.forEach(ele =>{
        this.typeFilStore.push({label: ele.trim(), value: ele.trim()});
      })
    }
  }

  public setStatusFilStore(ls){
    this.statusFilStore=[];
    if(ls.length!=0){
      ls.forEach(ele =>{
        this.statusFilStore.push({label: ele.trim(), value: ele.trim()})
      })
    }
  }

  public setCountryFilStore(ls){
    this.countryFilStore=[];
    if(ls.length!=0){
      ls.forEach(ele =>{
        this.countryFilStore.push({label: ele.trim(), value: ele.trim()})
      })
    }
  }

  public getfilteredData(filterDataObject:any): void {
    this.filterNotificationData.next(filterDataObject);
  }
}

